import React from 'react';

const RefreshIcon = ({ className = '' }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-black ${className}`}
  >
    <path
      d="M7.99988 16C5.76654 16 3.87488 15.225 2.32488 13.675C0.774878 12.125 -0.00012207 10.2333 -0.00012207 8C-0.00012207 5.76667 0.774878 3.875 2.32488 2.325C3.87488 0.775 5.76654 0 7.99988 0C9.14988 0 10.2499 0.2375 11.2999 0.7125C12.3499 1.1875 13.2499 1.86667 13.9999 2.75V0H15.9999V7H8.99988V5H13.1999C12.6665 4.06667 11.9374 3.33333 11.0124 2.8C10.0874 2.26667 9.08321 2 7.99988 2C6.33321 2 4.91654 2.58333 3.74988 3.75C2.58321 4.91667 1.99988 6.33333 1.99988 8C1.99988 9.66667 2.58321 11.0833 3.74988 12.25C4.91654 13.4167 6.33321 14 7.99988 14C9.28321 14 10.4415 13.6333 11.4749 12.9C12.5082 12.1667 13.2332 11.2 13.6499 10H15.7499C15.2832 11.7667 14.3332 13.2083 12.8999 14.325C11.4665 15.4417 9.83321 16 7.99988 16Z"
      fill="currentColor"
    />
  </svg>
);

export default RefreshIcon;
